var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 153 194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.5,0a42,42,0,1,0,42,42A42,42,0,0,0,76.5,0Zm0,67a25,25,0,1,1,25-25A25,25,0,0,1,76.5,67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.29,194a5.38,5.38,0,0,0,5.37-5.82c-.1-1.38-.16-2.77-.16-4.18a54,54,0,0,1,108,0c0,1.41-.06,2.8-.16,4.18a5.38,5.38,0,0,0,5.37,5.82h11.73a5.39,5.39,0,0,0,5.39-5c.11-1.65.17-3.31.17-5A76.5,76.5,0,0,0,0,184c0,1.67.06,3.33.17,5a5.39,5.39,0,0,0,5.39,5Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactos);
export default __webpack_public_path__ + "static/media/Contactos.7b3953df02f402ed8df6a26a2a9491e3.svg";
export { ForwardRef as ReactComponent };